module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMTQgNSA1MCAyNCI+CiAgPHBhdGggZD0iTTM3LjUgOC44djI0LjRIMTcuNEwzNy41IDguOHptMC04LjhjMCA1LjYtNC41IDEwLjEtMTAuMSAxMC4xcy0xMC00LjUtMTAtMTAuMWgyMC4xem0zLjMgMzMuMWMwLTUuNiA0LjUtMTAuMSAxMC4xLTEwLjFTNjEgMjcuNSA2MSAzMy4xSDQwLjh6bTAtOC43VjBINjFMNDAuOCAyNC40eiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zendesk-24px.svg
// module id = UB7c
// module chunks = 1